// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Subsonic__Empty from "./empty.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(param) {
  const params = {};
  return Fx.Monad_syntax.let$star(Subsonic__Utils.makeRequest({
    _method: "rest/ping",
    params: params
  }, Subsonic__Empty.of_json), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  }));
}

export {
  make,
}
/* No side effect */
